import { render } from "./Calendar.vue?vue&type=template&id=49817818&scoped=true"
import script from "./Calendar.vue?vue&type=script&lang=js"
export * from "./Calendar.vue?vue&type=script&lang=js"

import "./Calendar.vue?vue&type=style&index=0&id=49817818&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-49817818"

export default script